import screenPrinting from "../../images/icons/screenPrinting.png";
import embroidery from "../../images/icons/dEmbroidery.png";
import heatPress from "../../images/icons/heatPress.png";
import decalsAndBanners from "../../images/icons/decals-banners.png";

let servicesList = [
  {
    title: "Hybrid Printing",
    info: "Turning concepts into vibrant prints, we excel in the art of hybrid printing.",
    img: screenPrinting,
    alt: "hybrid printing icon",
    link: "/hybrid-printing",
  },
  {
    title: "Embroidery",
    info: "Expertly stitching imagination into fabric, we redefine embroidery.",
    img: embroidery,
    alt: "embroidery icon",
    link: "/embroidery",
  },
  {
    title: "Decals\u00A0&\u00A0Signage", //this wierd addition before and after the & is to make it a non breaking space
    info: "Crafting vibrant decals and banners, we bring your vision to life.",
    img: decalsAndBanners,
    alt: "decals and signage icon",
    link: "/decals-and-signage",
  },
  {
    title: "Heat Transfer",
    info: "Transforming ideas into wearable art, we specialize in precision heat transfers.",
    img: heatPress,
    alt: "heat press icon",
    link: "/heat-transfer",
  },
];
export default servicesList;
